import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Check, ShieldCheck, ChevronDown, Lock } from 'lucide-react';
import { Button, Section } from './Shared';
import { trackFb } from '../lib/fbpixel';
export function Pricing() {
  return <Section id="pricing" className="relative" data-id="element-65">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-brand-gold/5 via-brand-dark to-brand-dark -z-10" data-id="element-66" />

      <div className="text-center max-w-3xl mx-auto mb-10" data-id="element-67">
        <h2 className="text-3xl md:text-5xl font-bold text-white mb-5 leading-tight" data-id="element-68">
          Una obra documental para conservar, releer y volver a consultar.
        </h2>
        <p className="text-brand-muted text-base md:text-lg" data-id="element-69">
          Seis tomos de investigación central y tres investigaciones exclusivas
          incluidas para explorar cuando quieras.
        </p>
      </div>

      <div className="max-w-md mx-auto bg-gradient-to-b from-[#1c1813] via-brand-anthracite to-brand-anthracite rounded-2xl border border-brand-gold/60 shadow-[0_0_60px_rgba(197,160,89,0.25)] overflow-hidden relative" data-id="element-70">
        <div className="bg-gradient-to-r from-brand-gold via-brand-goldLight to-brand-gold text-brand-dark text-center py-2.5 text-xs font-bold tracking-[0.2em] uppercase" data-id="element-71">
          Oferta Especial de Lanzamiento
        </div>

        {/* Mockup sutil de la colección */}
        <div className="px-6 pt-6 pb-2" data-id="element-72">
          <div className="relative rounded-lg overflow-hidden border border-brand-gold/20 bg-brand-dark max-w-[260px] mx-auto" data-id="element-73">
            <img src="https://cdn.magicpatterns.com/uploads/3xV3KEMfNKP6BhhhrRPwUE/ChatGPT_Image_26_jun_2026,_20_42_04.png" alt="NOS MIENTEN: seis tomos y tres investigaciones exclusivas" className="w-full h-auto object-contain" data-id="element-74" />
            <div className="absolute inset-0 pointer-events-none ring-1 ring-inset ring-brand-gold/10 rounded-lg" data-id="element-75" />
          </div>
        </div>

        <div className="p-8 pt-5" data-id="element-76">
          <div className="text-center mb-8" data-id="element-77">
            <p className="text-brand-muted text-sm mb-1" data-id="element-78">
              Valor total del pack:
            </p>
            <p className="text-brand-muted/50 line-through text-lg mb-4" data-id="element-79">
              $97.937
            </p>

            <p className="text-brand-gold/90 text-sm font-bold uppercase tracking-wider mb-2" data-id="element-80">
              Precio de lanzamiento hoy:
            </p>
            <div className="text-5xl md:text-6xl font-serif font-bold text-transparent bg-clip-text bg-gradient-to-b from-brand-goldLight to-brand-gold mb-2 drop-shadow-[0_2px_12px_rgba(197,160,89,0.35)]" data-id="element-81">
              $24.990
            </div>
          </div>

          <div className="bg-brand-dark rounded-xl p-5 mb-8 border border-brand-gold/25" data-id="element-82">
            <p className="text-brand-gold font-bold text-sm mb-4 border-b border-brand-gold/20 pb-2 tracking-wide uppercase" data-id="element-83">
              Esto incluye hoy:
            </p>
            <ul className="space-y-3" data-id="element-84">
              {['NOS MIENTEN: investigación documental central', '6 tomos principales', 'Investigación exclusiva: El Libro Negro de los Misterios Modernos', 'Investigación exclusiva: Los Archivos Desclasificados', 'Investigación exclusiva: Las Grandes Civilizaciones Perdidas'].map((item, idx) => <li key={idx} className="flex items-start gap-3 text-sm text-brand-offWhite" data-id="element-85">
                  <Check className="w-4 h-4 text-brand-gold shrink-0 mt-0.5" data-id="element-86" />
                  <span data-id="element-87">{item}</span>
                </li>)}
            </ul>
          </div>

          <div className="space-y-2 mb-8" data-id="element-88">
            {['Acceso inmediato', 'Formato 100% digital', '3 investigaciones exclusivas incluidas', 'Compatible con celular, tablet y PC'].map((item, idx) => <div key={idx} className="flex items-center justify-center gap-2 text-xs text-brand-muted" data-id="element-89">
                <ShieldCheck className="w-3 h-3 text-brand-gold" data-id="element-90" />
                <span data-id="element-91">{item}</span>
              </div>)}
          </div>

          <Button fullWidth className="text-lg py-5" onClick={() => {
          trackFb('InitiateCheckout', {
            content_name: 'Colección NOS MIENTEN',
            content_type: 'product',
            currency: 'ARS',
            value: 27990
          });
          trackFb('Lead', {
            content_name: 'Colección NOS MIENTEN'
          });
          window.open('https://nos-mienten.impultienda.ar/checkout', '_blank', 'noopener,noreferrer');
        }} data-id="element-92">
            QUIERO OBTENER EL ACCESO
          </Button>

          <p className="text-center text-brand-red text-xs font-bold mt-4 uppercase tracking-wider" data-id="element-93">
            Oferta de lanzamiento disponible por tiempo limitado
          </p>
          <p className="text-center text-brand-muted text-[10px] mt-2" data-id="element-94">
            Pago único • Acceso inmediato • Lectura en todos tus dispositivos
          </p>
        </div>
      </div>
    </Section>;
}
export function Authority() {
  return <Section darker data-id="element-95">
      <div className="max-w-3xl mx-auto text-center bg-brand-anthracite border border-brand-card rounded-2xl px-6 py-10 md:px-12 md:py-14" data-id="element-96">
        <p className="text-xs font-bold tracking-[0.18em] text-brand-gold uppercase mb-5" data-id="element-97">
          Una historia por mirar de cerca
        </p>
        <h2 className="text-3xl md:text-5xl font-bold text-white leading-tight mb-7 whitespace-pre-line" data-id="element-98">
          Algunas historias fueron escritas para ser recordadas.{`\n\n`}Otras...
          {`\n\n`}
          <span className="text-brand-gold" data-id="element-99">Para ser olvidadas.</span>
        </h2>
        <div className="text-brand-muted text-base md:text-lg leading-relaxed space-y-5" data-id="element-100">
          <p data-id="element-101">
            Durante décadas aparecieron documentos, testimonios y casos que
            nunca lograron ocupar un lugar en la historia que la mayoría conoce.
          </p>
          <p className="text-brand-offWhite" data-id="element-102">
            Este libro reúne ese material para que puedas explorarlo desde una
            mirada documental y construir tus propias conclusiones.
          </p>
        </div>
      </div>
    </Section>;
}
export function Guarantee() {
  return <Section darker data-id="element-103">
      <div className="max-w-2xl mx-auto text-center bg-brand-anthracite p-8 md:p-12 rounded-2xl border border-brand-card" data-id="element-104">
        <ShieldCheck className="w-12 h-12 text-brand-gold mx-auto mb-6" data-id="element-105" />
        <h2 className="text-2xl font-bold text-white mb-4" data-id="element-106">
          Leé esta obra con tranquilidad
        </h2>
        <p className="text-brand-muted text-base leading-relaxed" data-id="element-107">
          Si al acceder sentís que el libro no tiene la profundidad, el contexto
          o el valor que esperabas, podés revisar la garantía disponible dentro
          del plazo correspondiente. Queremos que lo explores con confianza.
        </p>
      </div>
    </Section>;
}
const faqs = [{
  q: '¿En qué formato se entrega?',
  a: 'En formato PDF digital de alta calidad.'
}, {
  q: '¿Lo recibo al instante?',
  a: 'Sí. El acceso es inmediato después de completar la compra.'
}, {
  q: '¿Puedo leerlo desde el celular?',
  a: 'Sí. Podés leerlo desde celular, tablet, notebook o PC.'
}, {
  q: '¿Incluye las investigaciones exclusivas?',
  a: 'Sí. Las 3 investigaciones especiales mencionadas están incluidas en esta oferta.'
}, {
  q: '¿Incluye Antártida y Los Evangelios Perdidos?',
  a: 'No. Esas investigaciones especiales se desbloquean después de la compra con una oferta exclusiva para compradores.'
}, {
  q: '¿Es contenido básico o profundo?',
  a: 'Está diseñado para ser claro, visual y profundo, ideal para lectores curiosos y fanáticos del tema.'
}];
export function FAQ() {
  const [openIdx, setOpenIdx] = useState<number | null>(null);
  return <Section data-id="element-108">
      <div className="max-w-3xl mx-auto" data-id="element-109">
        <h2 className="text-2xl md:text-4xl font-bold text-white text-center mb-10" data-id="element-110">
          Preguntas Frecuentes
        </h2>
        <div className="space-y-3" data-id="element-111">
          {faqs.map((faq, idx) => <div key={idx} className="bg-brand-dark border border-brand-card rounded-lg overflow-hidden" data-id="element-112">
              <button onClick={() => setOpenIdx(openIdx === idx ? null : idx)} className="w-full px-6 py-4 flex items-center justify-between text-left focus:outline-none" data-id="element-113">
                <span className="font-medium text-white text-sm md:text-base" data-id="element-114">
                  {faq.q}
                </span>
                <ChevronDown className={`w-5 h-5 text-brand-gold transition-transform duration-300 ${openIdx === idx ? 'rotate-180' : ''}`} data-id="element-115" />
              </button>
              <AnimatePresence data-id="element-116">
                {openIdx === idx && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-117">
                    <div className="px-6 pb-4 text-brand-muted text-sm border-t border-brand-card/50 pt-4" data-id="element-118">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </Section>;
}
export function FinalCTA() {
  return <Section darker className="relative overflow-hidden !py-14 md:!py-16" data-id="element-119">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_bottom,_var(--tw-gradient-stops))] from-brand-gold/10 via-brand-dark to-brand-dark -z-10" data-id="element-120" />

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-121">
        <Lock className="w-8 h-8 text-brand-gold mx-auto mb-6 opacity-50" data-id="element-122" />
        <h2 className="text-3xl md:text-5xl font-bold text-white mb-6 leading-tight whitespace-pre-line" data-id="element-123">
          Si alguna vez sentiste que había piezas que no encajaban...{`\n\n`}
          <span className="text-brand-gold" data-id="element-124">
            Quizás este sea el libro que estabas buscando.
          </span>
        </h2>
        <div className="text-lg md:text-xl text-brand-muted mb-10 max-w-2xl mx-auto space-y-3" data-id="element-125">
          <p data-id="element-126">No para creer.</p>
          <p data-id="element-127">No para dejar de creer.</p>
          <p className="text-brand-offWhite" data-id="element-128">
            Sino para conocer información que rara vez aparece reunida en una
            sola obra.
          </p>
        </div>
        <Button onClick={() => {
        trackFb('AddToCart', {
          content_name: 'Colección NOS MIENTEN',
          currency: 'ARS',
          value: 27990
        });
        document.getElementById('pricing')?.scrollIntoView({
          behavior: 'smooth'
        });
      }} className="text-lg py-5 px-10" data-id="element-129">
          QUIERO LEER EL LIBRO
        </Button>
      </div>
    </Section>;
}